import {Injectable} from '@angular/core';
import * as atob from 'atob';
import {isEmpty} from 'lodash';

@Injectable()
export class JwtUtil {
    public isTokenExpired(token: string): boolean {
        if (isEmpty(token)) {
            throw new Error('Token is not provided.');
        }
        const payload = JSON.parse(atob(token.split('.')[1]));
        return isEmpty(payload) || Date.now() > payload.exp * 1000;
    }
}
